import React, { useContext, useState, useEffect } from 'react'; // Added useEffect
import { LanguageContext } from '../App';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const { language, setLanguage, t } = useContext(LanguageContext);
  const location = useLocation();

  // State for mobile sidebar visibility
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  // Determine if current view is mobile based on a common breakpoint (from App.css)
  const [isMobileView, setIsMobileView] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      // Call it once to set initial state correctly after mount
      handleResize();
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  const toggleLanguage = () => {
    setLanguage(language === 'ar' ? 'en' : 'ar');
  };

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const closeMobileSidebar = () => {
    if (isMobileView) { // Only close if in mobile view
      setMobileSidebarOpen(false);
    }
    // On desktop, clicking a nav link does not affect sidebar visibility
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const logoDataUrl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMTIiIGZpbGw9IiM4MDAwMjAiLz4KPHBhdGggZD0iTTQ4IDIwSDQwVjI4SDQ4VjIwWiIgZmlsbD0iI2Q0YWYzNyIvPgo8cGF0aCBkPSJNNDggMzJINDBWNDBINDhWMzJaIiBmaWxsPSIjZDRhZjM3Ii8+CjxwYXRoIGQ9Ik00OCA0NEg0MFY1Mkg0OFY0NFoiIGZpbGw9IiNkNGFmMzciLz4KPGNpcmNsZSBjeD0iMjYiIGN5PSIyNiIgcj0iMTAiIHN0cm9rZT0iI2Q0YWYzNyIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSJub25lIi8+CjxwYXRoIGQ9Ik0yNiAxOFYyNkwzMiAzMiIgc3Ryb2tlPSIjZDRhZjM3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";

  return (
    <div className="layout">
      {/* Mobile Menu Toggle - only visible on mobile via CSS */}
      <button className="mobile-menu-toggle" onClick={toggleMobileSidebar}>
        {mobileSidebarOpen ? '✕' : '☰'}
      </button>

      {/* Language Toggle */}
      <div className="language-toggle">
        <button onClick={toggleLanguage} className="btn btn-outline">
          {language === 'ar' ? 'EN' : 'العربية'}
        </button>
      </div>

      {/* Sidebar Overlay - only visible when mobileSidebarOpen and on mobile via CSS */}
      <div 
        className={`sidebar-overlay ${mobileSidebarOpen && isMobileView ? 'show' : ''}`}
        onClick={closeMobileSidebar}
      ></div>

      {/* Sidebar */}
      {/* The 'open' class is for mobile view. Desktop is always 'open' structurally */}
      <div className={`sidebar ${(mobileSidebarOpen && isMobileView) ? 'open' : ''}`}>
        <div className="logo-container">
          <img src={logoDataUrl} alt="Logo" className="logo mx-auto" />
          <h1 className="app-title">{t('appName')}</h1>
          <p className="app-subtitle">مدير مكتب تنفيذي</p>
        </div>

        <nav>
          <ul className="nav-menu">
            <li className="nav-item">
              <a 
                href="/" 
                className={`nav-link ${isActive('/') ? 'active' : ''}`}
                onClick={closeMobileSidebar} // Changed from closeSidebar
              >
                <span className="nav-icon">🏠</span>
                {t('dashboard')}
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="/tasks" 
                className={`nav-link ${isActive('/tasks') ? 'active' : ''}`}
                onClick={closeMobileSidebar} // Changed from closeSidebar
              >
                <span className="nav-icon">✅</span>
                {t('tasks')}
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="/calendar" 
                className={`nav-link ${isActive('/calendar') ? 'active' : ''}`}
                onClick={closeMobileSidebar} // Changed from closeSidebar
              >
                <span className="nav-icon">📅</span>
                {t('calendar')}
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="/settings" 
                className={`nav-link ${isActive('/settings') ? 'active' : ''}`}
                onClick={closeMobileSidebar} // Changed from closeSidebar
              >
                <span className="nav-icon">⚙️</span>
                {t('settings')}
              </a>
            </li>
          </ul>
        </nav>
      </div>

      {/* Main Content */}
      {/* Removed dynamic 'expanded' class. CSS media queries handle margins. */}
      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default Layout;